import React, { useEffect, useState } from "react";
import { Typography, Divider, Grid } from "@mui/material";
import useUserPermissionsContext from "../hooks/useUserPermissionsContext";
import { getVisibleFields, REDRAW_DEBOUNCE_TIMEOUT } from "./FormFactory";

export function FormGroup({ group, ...props }) {
  const UserPermissionsContext = useUserPermissionsContext;

  const [visibleFields, setVisibleFields] = useState(
    getVisibleFields({ group: group.fields, ...props, UserPermissionsContext })
  );
  const { formState, values, commonFieldProps, copyOneValue } = props;

  // Debouncing visibility check to allow smooth data-entry
  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisibleFields(
        getVisibleFields({
          group: group.fields,
          ...props,
          UserPermissionsContext,
        })
      );
    }, REDRAW_DEBOUNCE_TIMEOUT);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group, formState, values, commonFieldProps, copyOneValue]);

  // If it turns out all fields in this group are hidden, render nothing
  if (!visibleFields || visibleFields.length === 0) return null;

  return (
    <>

      {/* Hide divider for first group */}
      {props.groupIndex > 0 && <Divider sx={{ width: "100%", mb: 1 }} />}
      {group.title ? (
          <Typography variant='h6' className='groupHeader' >
            {group.title}
          </Typography>
      ) : (
        <></>
      )}

      <Grid container spacing={4} justifyContent={group.align === "right" ? "flex-end" : "flex-start"}>
        {visibleFields.map((field, idx) => {
          // If the field is a line break, render a placeholder Grid item
          if (field && field.key === '__placeholder__') {
            return <Grid item xs={2} key={idx} />;
          }
          return (
            <Grid item xs={2} key={idx}>
              {field}
            </Grid>
          );
        })}
      </Grid>

    </>
  );
}
